import { createStore, combineReducers } from 'redux';




import HeaderTickerReducer from './Reducer/HeaderTickerReducer';


const reducer = combineReducers({
    HeaderTicker: HeaderTickerReducer,
});

const store = createStore(reducer)

export default store;
export type RootReduxState = ReturnType<typeof reducer>